import React from "react";
import styled from "styled-components";
import {
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel
} from "@material-ui/core";

import { ReportStatusCheckboxes } from "../constants";

const StyledCard = styled(Card)`
  margin: 7px 10px 70px 10px;
  outline: 1px solid #dadce0;
  width: 95%;
`;

const StyledFormGroup = styled(FormGroup)`
  padding-left: 10px;
`;

const StyledFormLabel = styled(FormLabel)`
  && {
    color: #5f6368;
    text-transform: uppercase;
    font-family: "Work Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
  }
`;

const FilterDrawerReportStatusCard = ({ copyFilterState, updateFilterState }) => {
  const checkedState = copyFilterState.status;

  const handleOnChange = value => {
    const updatedCheckedState = {
      ...checkedState,
      [value]: !checkedState[value]
    };
    updateFilterState("status", updatedCheckedState);
  };

  return (
    <FormControl>
      <StyledCard>
        <CardContent>
          <StyledFormLabel>Report Status</StyledFormLabel>
          <StyledFormGroup>
            {ReportStatusCheckboxes.map(({ name, value }, index) => (
              <FormControlLabel
                key={index}
                control={<Checkbox checked={checkedState[value]} name={name} />}
                label={name}
                onChange={() => handleOnChange(value)}
              />
            ))}
          </StyledFormGroup>
        </CardContent>
      </StyledCard>
    </FormControl>
  );
};

export default FilterDrawerReportStatusCard;
